export default __webpack_public_path__ + "static/media/News.97ced562.svg";